export default __webpack_public_path__ + "static/media/amex-icon.5d18f9e8.svg";